import styled from "styled-components"

export const ReservationDetailsWrapper = styled.div<{
	status: "yellow" | "gray" | "green"
}>`
	.containerHeader {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 8px;
		p {
			margin: 0;
			color: #261b6a;
			font-size: 18px;
			font-weight: 700;
			line-height: 21.6px;
		}
		.containerButtons {
			display: flex;
			justify-content: space-between;
			align-items: center;
			gap: 8px;
		}
	}
	.channalAndStatus {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 16px;
		border-bottom: 1px solid #eaeafd;
		padding-bottom: 12px;
		margin-bottom: 12px;
		.channal {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			gap: 8px;
			> div {
				width: 30px;
				height: 30px;
				border-radius: 50px;
				overflow: hidden;
				svg {
					width: 100%;
					height: 100%;
				}
			}
			p {
				margin: 0;
				color: #435363;
				font-size: 18px;
				font-weight: 400;
			}
		}
		.status {
			padding: 10px 12px;
			border-radius: 50px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			gap: 6px;
			background-color: ${(props) =>
				props.status === "yellow"
					? "#FFF7E1"
					: props.status === "gray"
						? "#E2E2E2"
						: props.status === "green"
							? "#D5F7D8"
							: "#FFF7E1"};
			border: ${(props) =>
				props.status === "yellow"
					? "1px solid #FFE9A9"
					: props.status === "gray"
						? "1px solid #C4C4C4"
						: props.status === "green"
							? "1px solid #B6E5BB"
							: "1px solid #FFE9A9"};
			span {
				color: #435363;
				font-size: 14px;
				font-weight: 400;
				line-height: 16.8px;

				&:first-of-type {
					border-radius: 50px;
					background-color: ${(props) =>
						props.status === "yellow"
							? "#FFE9A9"
							: props.status === "gray"
								? "#C4C4C4"
								: props.status === "green"
									? "#B6E5BB"
									: "#FFE9A9"};
					width: 9px;
					height: 9px;
				}
			}
		}
	}

	.infoSection {
		border-bottom: 1px solid #eaeafd;
		padding-bottom: 12px;
		margin-bottom: 12px;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		flex-wrap: wrap;
		p {
			margin: 0;
		}
		.iconSection {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			color: #5b3fff;
			svg {
				width: 20px;
				height: 20px;
			}
		}
		.titleSection {
			margin-top: 8px;
			p {
				font-size: 12px;
				font-weight: 400;
				line-height: 14.4px;
				color: #8e98a1;
			}
		}
		.detailsSection {
			margin-top: 16px;
			p {
				font-size: 14px;
				font-weight: 400;
				line-height: 16.8px;
				color: #0f172a;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				gap: 5px;
				.handleCopyClick {
					cursor: copy;
				}
				&:last-child {
					margin-top: 16px;
					&.guestPhoneNumber {
						direction: ltr;
					}
					span {
						&:nth-child(2) {
							font-size: 14px;
							font-weight: 400;
							line-height: 16.8px;
							color: #5b3fff;
						}
					}
				}
			}
		}
	}

	.dateAndTimeSection {
		border-bottom: 1px solid #eaeafd;
		padding-bottom: 12px;
		margin-bottom: 12px;
		p {
			margin: 0;
		}
		.iconSection {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			color: #5b3fff;
			svg {
				width: 20px;
				height: 20px;
			}
		}
		.titleSection {
			margin-top: 8px;
			p {
				font-size: 12px;
				font-weight: 400;
				line-height: 14.4px;
				color: #8e98a1;
			}
		}
		.dateAndTime {
			margin-top: 16px;
			.cotainer {
				border-right: 2px solid #5b3fff;
				padding-right: 6px;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				gap: 10px;
				p {
					font-size: 12px;
					font-weight: 500;
					line-height: 14.4px;
					color: #0f172a;
				}
				.time {
					border: 1px solid #e5e7eb;
					padding: 11px 14px;
					border-radius: 50px;
					color: #8e98a1;
					font-size: 12px;
					font-weight: 500;
					line-height: 24px;
				}
			}
		}
	}
	.pricingSection {
		border-bottom: 1px solid #eaeafd;
		padding-bottom: 12px;
		margin-bottom: 12px;
		.iconSection {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			color: #5b3fff;
			svg {
				width: 20px;
				height: 20px;
			}
		}
		.titleSection {
			margin-top: 8px;
			p {
				font-size: 12px;
				font-weight: 400;
				line-height: 14.4px;
				color: #8e98a1;
			}
		}
		.detailsSection {
			margin-top: 16px;
			p {
				font-size: 14px;
				font-weight: 400;
				line-height: 16.8px;
				color: #0f172a;
				&:last-child {
					margin-top: 16px;
					span {
						&:nth-child(2) {
							font-size: 14px;
							font-weight: 400;
							line-height: 16.8px;
							color: #5b3fff;
						}
					}
				}
			}
		}
		p {
			margin: 0;
		}
	}
	.smartAccessSection {
		padding-bottom: 12px;
		margin-bottom: 12px;
		.containerInfoMessage {
			border-bottom: 1px solid #eaeafd;
			padding-bottom: 12px;
			margin-bottom: 12px;
			p {
				margin: 0;
				padding: 0;
				font-size: 12px;
				font-weight: 400;
				line-height: 14.4px;
			}
		}
	}
`
export const AbsenceButtonWrapper = styled.div<{ show: boolean }>`
  display: ${props => props.show ? "flex" : "none"};
  align-items: end;
  justify-content: left;
  margin-top: 10px;

  button {
    width: 80px;
    height: 30px;
    border-radius: 50px;
    padding: 12px 16px;
    gap: 10px;
    background-color: #5B3FFF;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    
    h6 {
      color: #fff;
      margin: 0;
    }
  }
`;



export const DetailsBreakdown = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 24px;

    p {
      font-size: 14px;
      margin: 0;
    }

    &.bold p {
      font-weight: 500;
    }

    &.muted p {
      font-weight: 400;
      color: #8E98A1;
    }

    &.total {
      border-top: 1px solid #D9D9D9;
      padding-top: 18px;
      padding-bottom: 24px;

      p {
        font-weight: 700;

        &:last-child {
          color: #5B3FFF;
        }
      }
    }
  }
`;
